function campaignAccessDialog () {
  return {
    restrict: 'E',
    templateUrl: '/campaigns/dialogs/campaign-access/campaign-access-dialog.html?$$REVISION$$'
  }
}

export { campaignAccessDialog }
